import { render } from "./EditSocialModal.vue?vue&type=template&id=4e541dce"
import script from "./EditSocialModal.vue?vue&type=script&lang=js"
export * from "./EditSocialModal.vue?vue&type=script&lang=js"

import "./EditSocialModal.vue?vue&type=style&index=0&id=4e541dce&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__